<template>
<ValidationProvider tag="div" :rules="rules" :label="label" :vid="vid" v-slot="{ errors }">
    <div>

        <label>{{label}}</label>
        <!-- deselect-label="Can't remove this value" placeholder="Select one" -->
        <multiselect v-model="selValueModel" :disabled="isDisable" :track-by=ctrlCode :label=ctrlName :showLabels="false"
        placeholder="Select" :options="options" :searchable="isSearchable" :multiple="isMultiple" :allow-empty="true" :loading="isInValidOptions()" @input="emitVal" deselectLabel="" deselectGroupLabel="" selectLabel="" selectedLabel="">
            <template slot="singleLabel" slot-scope="{ option }"> {{ option[ctrlName] }}</template>
            <template slot="option" slot-scope="props">
                <div><span>{{ props.option[ctrlName] }}</span>
                    <strong class="right" v-if="isShowCode">{{ props.option[ctrlCode] }}</strong>
                </div>
            </template>
                <span slot="noResult"><strong>{{ $t("cCurrencyDropdown.noMatchFound") }}</strong></span>

        </multiselect>

        <div  v-if=" errors && errors[0]" class="invalid-feedback icon">
            <div v-show="!selValueModel || selValueModel.length==0">
                <span>{{ errors[0] }}</span>
            </div>
        </div>
    </div>

    <div v-show="noAgents">{{$t("cAlert.noData")}}</div>
    <div v-show="showAlert">
<CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>    </div>
</ValidationProvider>
</template>

<script>
import {
    ValidationProvider
} from "vee-validate";
import Multiselect from "vue-multiselect";
import apiGetCurrencyLs from "../../services/apiGetCurrencyLs.js";
import {
    mapGetters,
    mapActions
} from "vuex";
import {
    PAGE_NAME,ORDER
} from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import {
    VALIDATE_SUCCESS_RES,
    getErrorMessage
} from "../../util/apiValidate.js";
import {
    handleJWT,
    getErrorAlertValue,OrderByList
} from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
import Logger from "../../services/logger";
import {
    LOG_TYPE,
    FILE_NAME,
    HTTP_CODES,
    API_VALUES
} from "../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME } from "../../util/constants";
export default {
    name: COMPONENT_NAME.C_CURRENCYDP,
    components: {
        ValidationProvider,
        Multiselect
    },
    model: {
        prop: "selValue"
    },
	
	
	 props: {
         isDisable: {
      type: Boolean,
      default: false
    },
        selValue: {
            type: Object | Array,
            default: []
        },
        isShowCode: {
            type: Boolean,
            default: false
        },

        isMultiple: {
            type: Boolean,
            default: false
        },
        isSearchable: {
            type: Boolean,
            default: false
        },
        ctrlName: {
            type: String,
            default: ""
        },
        ctrlCode: {
            type: String,
            default: ""
        },
        url: {
            type: String,
            default: null
        },
        rules: {
            type: [String, Object],
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        vid: {
            type: String,
            default: undefined
        },
        value: {
            type: Object,
            default: null
        },
        defaultCurrencyCode: {
            type: String,
            default: null
        },
        // countryCode: {
        //     type: String,
        //     default: null
        // }

    },
    data: () => ({

        options: [],
        selected: false,
        selValueModel: {
            name: null,
            code: null,
            symbol: null,
            amount: null
        },
        showAlert: false,
        noAgents: false,
        alertValue: null,

    }),

    watch: {
        //this.selValueModel = this.selValue;
        selValue(val) {
            if (val !== this.selValueModel) {
                this.selValueModel = val;
            }

        }
    },

  async created() {
      this.selValueModel = this.selValue;
      await this.getCurrencyDpOptions();
    this.options=OrderByList(this.options,this.getPropToSortCurrList,ORDER.ASC);


    

  },
    computed: {
        ...mapGetters("sCurrencyLs", {
            currencyRes: "GET_CURRENCY_RES",
        }),

    },

    methods: {

        ...mapActions("sCurrencyLs", ["SET_CURRENCY_RES"]),

        emitVal(value) {
            this.$emit('input', value);
        },
    //      onAddTag(pTag) {
    //     try {
    //       if(BaseConfiguration.isDebug) console.log("onAddTag");
    //     let tag={
    //     code:pTag,
    //     name:pTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
    //     symbol:pTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
    //     }

    //     this.options.push(tag)
    //     if(this.selValueModel&&this.selValueModel.length){
    //         this.selValueModel.push(tag);
    //     }else{
    //   this.selValueModel=tag;
    //     }
    //        this.emitVal(this.selValueModel);         

    //     } catch (err) {
    //             let body = Logger.buildRequest(
    //               FILE_NAME.C_CURRENCYDP,
    //               "error in onAddTag",
    //               err.toString(),
    //               "onAddTag",
    //               LOG_TYPE.ERROR
    //             );
    //             Logger.getResponse(body);
    //           }
          
    //     }, 
getPropToSortCurrList(pCurr) {
         try {
           if(BaseConfiguration.isDebug) console.log("getPropToSortCurrList");
          if(pCurr.code){
            return pCurr.code.toLowerCase();
          }
     
         } catch (err) {
                 let body = Logger.buildRequest(
                    COMPONENT_NAME.C_CURRENCYDP,
                   "error in getPropToSortCurrList",
                   err.toString(),
                   "getPropToSortCurrList",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           
         }, 
        async getCurrencyDpOptions(){
            try {
                 if (this.currencyRes== null) {
              this.options = await this.getCurrencyListRes();
              if(!(this.selValueModel))
                {
                  this.selValueModel = this.getDefaultCurrencyCode(this.options);
                
                if(this.isMultiple) {
                  this.emitVal([this.selValueModel]);
                }else{
                  this.emitVal(this.selValueModel);
                }
                }
                
            } else {
              this.options = this.currencyRes;
              
              if(!(this.selValueModel))
                {
                  this.selValueModel= this.getDefaultCurrencyCode(this.options);
                
                if(this.isMultiple) {
                  this.emitVal([this.selValueModel]);
                }else{
                  this.emitVal(this.selValueModel);
                }
                }
                
              if (BaseConfiguration.isDebug) console.log("options from store!");
			}
            } catch (err) {
                    let body = Logger.buildRequest(
                      FILE_NAME.APPROVE_AGENT,
                      "error in getCurrencyDpOptions",
                      err.toString(),
                      "getCurrencyDpOptions",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
        },
      
        getDefaultCurrencyCode(pOptionsList) {
            let retValue ;
            try {
                if (pOptionsList != null && pOptionsList.length > 0) {
                    for (let i = 0; i < pOptionsList.length; i++) {
                        if(this.defaultCurrencyCode){
                            if (pOptionsList[i].code == this.defaultCurrencyCode) {
                            retValue = pOptionsList[i];
                            break;
                        }

                        }
                        // else if(this.countryCode){
                        //     if (pOptionsList[i].countryCode == this.countryCode) {
                        //     retValue = pOptionsList[i];
                        //     break;
                        //     }
                        // }
                            else if (pOptionsList[i].code == BaseConfiguration.defaultCurrencyObj.code) {
                            retValue = pOptionsList[i];
                            break;
                        }
                    }
                } else {
                    throw "invalid options list"
                }
            } catch (err) {
                let body = Logger.buildRequest(FILE_NAME.cCurrencyDropDown, "error in dropdown options", err.toString(), "getDefaultCurrencyCode", LOG_TYPE.ERROR);
                Logger.getResponse(body);
            }

            return retValue;
        },

        isInValidOptions() {
            let retValue = false;
            if (this.options && this.options.length > 0)
                //check options length
                retValue = false;
            else retValue = true;
            return retValue;
        },

        //api call to get currency list
        async getCurrencyListRes() {
            // this.countrySel=true;
            let retValue;
            try {

                let currencyLsResponse = await apiGetCurrencyLs.getResponse();
                if (
                    VALIDATE_SUCCESS_RES(currencyLsResponse) &&
                    currencyLsResponse.data.data.length > 0
                ) {
                    this.SET_CURRENCY_RES(currencyLsResponse.data.data); //save res in store
                    retValue = currencyLsResponse.data.data;
                    // console.log(countryLsResponse.data.data);
                } else {
                    this.showAlert = true;

                    let error = getErrorMessage(currencyLsResponse);

                    let isJwt = handleJWT(error);
                    if (!isJwt) {
                        this.alertValue = getErrorAlertValue(error)
                    }
                }

                //  } else {
                //     throw "invalid country request"; 
                //   }
            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.API_GET_CURRENCY_LIST,
                    "error in getting response from GetCurrencyLs API",
                    err.toString(),
                    "GetCurrencyLsRes",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
            return retValue;
        },

    }
};
</script>


